import type { AITestDto } from "@mmm/contracts";
import { TestList } from "../organisms/TestList.js";
import { EmptyState, useT } from "@mmm/ui";
export function TestsOverview({ tests, subjectId }: { tests: AITestDto[]; subjectId: string }) {
  const t = useT();
  return <section className="mmm-tests-overview">
    <h2>{t("nav.tests")}</h2>
    {tests.length ? <TestList tests={tests} subjectId={subjectId} /> : <EmptyState title={t("tests.noTestsTitle")} message={t("tests.noTestsMessage")} />}
  </section>;
}
